import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { WHContentPageRoutingModule } from './w-h-content-page-routing.module';
import { WHContentPageComponent } from './w-h-content-page/w-h-content-page.component';
import { AppSharedModule } from '../app-shared/app-shared.module';
import { WHSearchTermUtilModule } from '../app-modules-pages/w-h-search-term-util/w-h-search-term-util.module';
import { TeamListComponent } from './w-h-content-page/team-list/team-list.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import {
  WHBreadcrumbsComponent,
  WHSharedModule,
  WHImgAuthHeaderModule,
} from '@workheld/workheld-shared-lib';
@NgModule({
  declarations: [WHContentPageComponent, TeamListComponent],
  exports: [WHContentPageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    WHSharedModule,
    WHBreadcrumbsComponent,
    WHImgAuthHeaderModule,
    MatIconModule,
    AppSharedModule,
    MatMenuModule,
    MatCardModule,
    WHContentPageRoutingModule,
    WHSearchTermUtilModule,
  ],
})
export class WHContentPageModule {}
